import safeLocalStorage from 'common/support/safeLocalStorage';
import { VideoCtvRedux, Color, NamedFontSize, FontFamily, TextShadow, Opacity } from 'store-types';
import { AppDispatch } from 'app-types';

export const SET_CC_ALL = 'SET_CC_ALL' as const;
export const SET_CC_TEXT_SIZE = 'SET_CC_TEXT_SIZE' as const;
export const SET_CC_TEXT_COLOR = 'SET_CC_TEXT_COLOR' as const;
export const SET_CC_TEXT_TYPE = 'SET_CC_TEXT_TYPE' as const;
export const SET_CC_TEXT_OPACITY = 'SET_CC_TEXT_OPACITY' as const;
export const SET_CC_TEXT_SHADOW = 'SET_CC_TEXT_SHADOW' as const;
export const SET_CC_TEXT_SHADOW_COLOR = 'SET_CC_TEXT_SHADOW_COLOR' as const;
export const SET_CC_BACKGROUND_COLOR = 'SET_CC_BACKGROUND_COLOR' as const;
export const SET_CC_BACKGROUND_OPACITY = 'SET_CC_BACKGROUND_OPACITY' as const;
export const SET_CC_WINDOW_COLOR = 'SET_CC_WINDOW_COLOR' as const;
export const SET_CC_WINDOW_OPACITY = 'SET_CC_WINDOW_OPACITY' as const;

const CLOSED_CAPTION_SETTINGS_KEY = 'closedCaptionSettings';

export const intializeClosedCaptionSettings = () => {
  const localStorageCCSettings = safeLocalStorage.getItem(
    CLOSED_CAPTION_SETTINGS_KEY,
  );

  return {
    type: SET_CC_ALL,
    payload: JSON.parse(localStorageCCSettings),
  };
};

export const setTextSize = (textSize: NamedFontSize) => (dispatch: AppDispatch<VideoCtvRedux>, getState: () => VideoCtvRedux) => {
  const { ...rest } = getState().closedCaptionSettings;

  const settings = {
    ...rest,
    textSize,
  };

  safeLocalStorage.setItem(
    CLOSED_CAPTION_SETTINGS_KEY,
    JSON.stringify(settings),
  );

  dispatch({
    type: SET_CC_TEXT_SIZE,
    payload: textSize,
  });
};

export const setTextColor = (textColor: Color) => (dispatch: AppDispatch<VideoCtvRedux>, getState: () => VideoCtvRedux) => {
  const { ...rest } = getState().closedCaptionSettings;

  const settings = {
    ...rest,
    textColor,
  };

  safeLocalStorage.setItem(
    CLOSED_CAPTION_SETTINGS_KEY,
    JSON.stringify(settings),
  );

  dispatch({ type: SET_CC_TEXT_COLOR, payload: textColor });
};

export const setTextType = (textType: FontFamily) => (dispatch: AppDispatch<VideoCtvRedux>, getState: () => VideoCtvRedux) => {
  const { ...rest } = getState().closedCaptionSettings;

  const settings = {
    ...rest,
    textType,
  };

  safeLocalStorage.setItem(
    CLOSED_CAPTION_SETTINGS_KEY,
    JSON.stringify(settings),
  );

  dispatch({
    type: SET_CC_TEXT_TYPE,
    payload: textType,
  });
};

export const setTextOpacity = (textOpacity: Opacity) => (dispatch: AppDispatch<VideoCtvRedux>, getState: () => VideoCtvRedux) => {
  const { ...rest } = getState().closedCaptionSettings;

  const settings = {
    ...rest,
    textOpacity,
  };

  safeLocalStorage.setItem(
    CLOSED_CAPTION_SETTINGS_KEY,
    JSON.stringify(settings),
  );

  dispatch({
    type: SET_CC_TEXT_OPACITY,
    payload: textOpacity,
  });
};

export const setTextShadow = (textShadow: TextShadow) => (dispatch: AppDispatch<VideoCtvRedux>, getState: () => VideoCtvRedux) => {
  const { ...rest } = getState().closedCaptionSettings;

  const settings = {
    ...rest,
    textShadow,
  };

  safeLocalStorage.setItem(
    CLOSED_CAPTION_SETTINGS_KEY,
    JSON.stringify(settings),
  );

  dispatch({
    type: SET_CC_TEXT_SHADOW,
    payload: textShadow,
  });
};

export const setTextShadowColor = (textShadowColor: Color) => (dispatch: AppDispatch<VideoCtvRedux>, getState: () => VideoCtvRedux) => {
  const { ...rest } = getState().closedCaptionSettings;

  const settings = {
    ...rest,
    textShadowColor,
  };

  safeLocalStorage.setItem(
    CLOSED_CAPTION_SETTINGS_KEY,
    JSON.stringify(settings),
  );

  dispatch({
    type: SET_CC_TEXT_SHADOW_COLOR,
    payload: textShadowColor,
  });
};

export const setBackgroundColor = (backgroundColor: Color) => (dispatch: AppDispatch<VideoCtvRedux>, getState: () => VideoCtvRedux) => {
  const { ...rest } = getState().closedCaptionSettings;

  const settings = {
    ...rest,
    backgroundColor,
  };

  safeLocalStorage.setItem(
    CLOSED_CAPTION_SETTINGS_KEY,
    JSON.stringify(settings),
  );

  dispatch({
    type: SET_CC_BACKGROUND_COLOR,
    payload: backgroundColor,
  });
};

export const setBackgroundOpacity = (backgroundOpacity: Opacity) => (
  dispatch: AppDispatch<VideoCtvRedux>,
  getState: () => VideoCtvRedux,
) => {
  const { ...rest } = getState().closedCaptionSettings;

  const settings = {
    ...rest,
    backgroundOpacity,
  };

  safeLocalStorage.setItem(
    CLOSED_CAPTION_SETTINGS_KEY,
    JSON.stringify(settings),
  );

  dispatch({
    type: SET_CC_BACKGROUND_OPACITY,
    payload: backgroundOpacity,
  });
};

export const setWindowColor = (windowColor: Color) => (dispatch: AppDispatch<VideoCtvRedux>, getState: () => VideoCtvRedux) => {
  const { ...rest } = getState().closedCaptionSettings;

  const settings = {
    ...rest,
    windowColor,
  };

  safeLocalStorage.setItem(
    CLOSED_CAPTION_SETTINGS_KEY,
    JSON.stringify(settings),
  );

  dispatch({
    type: SET_CC_WINDOW_COLOR,
    payload: windowColor,
  });
};

export const setWindowOpacity = (windowOpacity: Opacity) => (dispatch: AppDispatch<VideoCtvRedux>, getState: () => VideoCtvRedux) => {
  const { ...rest } = getState().closedCaptionSettings;

  const settings = {
    ...rest,
    windowOpacity,
  };

  safeLocalStorage.setItem(
    CLOSED_CAPTION_SETTINGS_KEY,
    JSON.stringify(settings),
  );

  dispatch({
    type: SET_CC_WINDOW_OPACITY,
    payload: windowOpacity,
  });
};
